// @generated by protobuf-ts 2.4.0 with parameter long_type_number,generate_dependencies,optimize_code_size,ts_nocheck,// @generated from protobuf file "apis/sparx/games/state/blocksgame/v1/blocksgame.proto" (package "sparx.games.state.blocksgame.v1", syntax proto3),// tslint:disable
// @ts-nocheck
import { MessageType } from '@protobuf-ts/runtime';
/**
 * @generated from protobuf message sparx.games.state.blocksgame.v1.Store
 */
export interface Store {
  /**
   * @generated from protobuf field: uint32 completionCount = 1;
   */
  completionCount: number;
}
/**
 * @generated from protobuf message sparx.games.state.blocksgame.v1.State
 */
export interface State {
  /**
   * @generated from protobuf field: sparx.games.state.blocksgame.v1.ChallengeDef challenge = 1;
   */
  challenge?: ChallengeDef;
  /**
   * @generated from protobuf field: uint32 diceCount = 2;
   */
  diceCount: number;
  /**
   * @generated from protobuf field: float duration = 3;
   */
  duration: number;
  /**
   * @generated from protobuf field: sparx.games.state.blocksgame.v1.State.WinState winState = 4;
   */
  winState: State_WinState;
}
/**
 * @generated from protobuf enum sparx.games.state.blocksgame.v1.State.WinState
 */
export enum State_WinState {
  /**
   * @generated from protobuf enum value: none = 0;
   */
  none = 0,
  /**
   * @generated from protobuf enum value: won = 1;
   */
  won = 1,
  /**
   * @generated from protobuf enum value: lost = 2;
   */
  lost = 2,
}
/**
 * @generated from protobuf message sparx.games.state.blocksgame.v1.Init
 */
export interface Init {
  /**
   * @generated from protobuf field: sparx.games.state.blocksgame.v1.ChallengeDef challenge = 1;
   */
  challenge?: ChallengeDef;
  /**
   * @generated from protobuf field: float duration = 2;
   */
  duration: number;
  /**
   * @generated from protobuf field: repeated string vips = 3;
   */
  vips: string[];
  /**
   * @generated from protobuf field: uint32 completionCount = 4;
   */
  completionCount: number;
}
/**
 * @generated from protobuf message sparx.games.state.blocksgame.v1.Action
 */
export interface Action {
  /**
   * @generated from protobuf field: sparx.games.state.blocksgame.v1.Action.ActionType actionType = 1;
   */
  actionType: Action_ActionType;
}
/**
 * @generated from protobuf enum sparx.games.state.blocksgame.v1.Action.ActionType
 */
export enum Action_ActionType {
  /**
   * @generated from protobuf enum value: quitGame = 0;
   */
  quitGame = 0,
  /**
   * @generated from protobuf enum value: flagWinState = 1;
   */
  flagWinState = 1,
  /**
   * @generated from protobuf enum value: flagLoseState = 2;
   */
  flagLoseState = 2,
}
/**
 * @generated from protobuf message sparx.games.state.blocksgame.v1.Update
 */
export interface Update {}
/**
 * @generated from protobuf message sparx.games.state.blocksgame.v1.Params
 */
export interface Params {}
/**
 * @generated from protobuf message sparx.games.state.blocksgame.v1.ChallengeDef
 */
export interface ChallengeDef {
  /**
   * A value between 0 and 1 to represent how "bunched up" the shapes will be.
   * 0 = very spaced out, 1 = very bunched-up
   * We expect 0 to be easier and 1 to be harder
   *
   * @generated from protobuf field: float connectedness = 1;
   */
  connectedness: number;
  /**
   * An array of the types of block that can be used in this challenge:
   * - "simple" = Tetris shapes
   * - "medium" = more complex shapes with 5 squares
   * - "complex" = even more complex shapes
   *
   * @generated from protobuf field: repeated string blockTypes = 2;
   */
  blockTypes: string[];
  /**
   * The kind of shape transformation allowed when calculating the grid
   *  - "rotation" gives grids where the user only needs to rotate the shape
   *  - null gives grids where rotation and reflection can be used
   *
   * @generated from protobuf field: string transformationType = 3;
   */
  transformationType: string;
  /**
   * The ID of a pre-determined puzzle to be constructed. If null, the game
   * will construct a puzzle algorithmically (usually is left null)
   *
   * @generated from protobuf field: string predefinedPuzzle = 4;
   */
  predefinedPuzzle: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class Store$Type extends MessageType<Store> {
  constructor() {
    super('sparx.games.state.blocksgame.v1.Store', [
      {
        no: 1,
        name: 'completionCount',
        kind: 'scalar',
        T: 13 /*ScalarType.UINT32*/,
      },
    ]);
  }
}
/**
 * @generated MessageType for protobuf message sparx.games.state.blocksgame.v1.Store
 */
export const Store = new Store$Type();
// @generated message type with reflection information, may provide speed optimized methods
class State$Type extends MessageType<State> {
  constructor() {
    super('sparx.games.state.blocksgame.v1.State', [
      { no: 1, name: 'challenge', kind: 'message', T: () => ChallengeDef },
      { no: 2, name: 'diceCount', kind: 'scalar', T: 13 /*ScalarType.UINT32*/ },
      { no: 3, name: 'duration', kind: 'scalar', T: 2 /*ScalarType.FLOAT*/ },
      {
        no: 4,
        name: 'winState',
        kind: 'enum',
        T: () => [
          'sparx.games.state.blocksgame.v1.State.WinState',
          State_WinState,
        ],
      },
    ]);
  }
}
/**
 * @generated MessageType for protobuf message sparx.games.state.blocksgame.v1.State
 */
export const State = new State$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Init$Type extends MessageType<Init> {
  constructor() {
    super('sparx.games.state.blocksgame.v1.Init', [
      { no: 1, name: 'challenge', kind: 'message', T: () => ChallengeDef },
      { no: 2, name: 'duration', kind: 'scalar', T: 2 /*ScalarType.FLOAT*/ },
      {
        no: 3,
        name: 'vips',
        kind: 'scalar',
        repeat: 2 /*RepeatType.UNPACKED*/,
        T: 9 /*ScalarType.STRING*/,
      },
      {
        no: 4,
        name: 'completionCount',
        kind: 'scalar',
        T: 13 /*ScalarType.UINT32*/,
      },
    ]);
  }
}
/**
 * @generated MessageType for protobuf message sparx.games.state.blocksgame.v1.Init
 */
export const Init = new Init$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Action$Type extends MessageType<Action> {
  constructor() {
    super('sparx.games.state.blocksgame.v1.Action', [
      {
        no: 1,
        name: 'actionType',
        kind: 'enum',
        T: () => [
          'sparx.games.state.blocksgame.v1.Action.ActionType',
          Action_ActionType,
        ],
      },
    ]);
  }
}
/**
 * @generated MessageType for protobuf message sparx.games.state.blocksgame.v1.Action
 */
export const Action = new Action$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Update$Type extends MessageType<Update> {
  constructor() {
    super('sparx.games.state.blocksgame.v1.Update', []);
  }
}
/**
 * @generated MessageType for protobuf message sparx.games.state.blocksgame.v1.Update
 */
export const Update = new Update$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Params$Type extends MessageType<Params> {
  constructor() {
    super('sparx.games.state.blocksgame.v1.Params', []);
  }
}
/**
 * @generated MessageType for protobuf message sparx.games.state.blocksgame.v1.Params
 */
export const Params = new Params$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChallengeDef$Type extends MessageType<ChallengeDef> {
  constructor() {
    super('sparx.games.state.blocksgame.v1.ChallengeDef', [
      {
        no: 1,
        name: 'connectedness',
        kind: 'scalar',
        T: 2 /*ScalarType.FLOAT*/,
      },
      {
        no: 2,
        name: 'blockTypes',
        kind: 'scalar',
        repeat: 2 /*RepeatType.UNPACKED*/,
        T: 9 /*ScalarType.STRING*/,
      },
      {
        no: 3,
        name: 'transformationType',
        kind: 'scalar',
        T: 9 /*ScalarType.STRING*/,
      },
      {
        no: 4,
        name: 'predefinedPuzzle',
        kind: 'scalar',
        T: 9 /*ScalarType.STRING*/,
      },
    ]);
  }
}
/**
 * @generated MessageType for protobuf message sparx.games.state.blocksgame.v1.ChallengeDef
 */
export const ChallengeDef = new ChallengeDef$Type();
